export const expiryMonth = (expiry: string) => {
  return parseInt(expiry.split('/')[0])
}
